export const TypographyP = ({
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => {
  return <p className="leading-7 [&:not(:first-child)]:mt-6" {...props} />;
};
